import React, { Component } from 'react';
import {
  ActivityIndicator,
  Dimensions,
  Image,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';

import { KeyboardAwareScrollView } from '../modules';
import Utils from '../utils/Utils';
import APIClient from '../utils/APIClient';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class EditOrderScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
      headerTitle: 'Chỉnh sửa đơn hàng',
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      paymentMethod: '',
      promoCode: '',
      address: '',
      name: '',
      shippingCode: '',
      status: 'none',
    };

    this._id = Platform.OS === 'web'
      ? this.props.match.params.id
      : this.props.navigation.state.params.id;
  }

  componentDidMount () {
    InteractionManager.runAfterInteractions(this._loadData);
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _loadData = async () => {
    const {status} = this.state;
    if (status === 'loading') {
      return;
    }

    this.setState({
      status: 'loading',
    });

    const path = `/order/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse = (response, error) => {
    if (response && response.response) {
      this.setState({
        status: 'succeed',
      });
      const {order, customer, seller} = response.response;
      this.setState({
        paymentMethod: _.isEmpty(order.paymentMethod)
          ? ''
          : order.paymentMethod,
        promoCode: _.isEmpty(seller.promoCode) ? '' : seller.promoCode,
        address: _.isEmpty(customer.address) ? '' : customer.address,
        name: _.isEmpty(customer.name) ? '' : customer.name,
        shippingCode: _.isEmpty(order.shippingCode) ? '' : order.shippingCode,
      });
    } else {
      this.setState({
        status: 'failed',
      });
      const message = Utils.parseErrorMessage(response, error,
        'Có lỗi xảy ra, vui lòng thử lại sau');
      AlertUtils.alert({message});
    }
  };

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    this.setState({
      submitting: true,
    });

    const {paymentMethod, promoCode, address, name, shippingCode} = this.state;
    const path = `/order/${this._id}`;
    const data = {
      payment_method: paymentMethod,
      promo_code: promoCode,
      address,
      name,
      shipping_code: shippingCode,
    };
    const {response, error} = await APIClient.POST(path, data);
    this._handleSubmitNetworkResponse(response, error);
  };

  _handleSubmitNetworkResponse = (response, error) => {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    if (response && response.response) {
      const message =
        _.isEmpty(response.response.message)
          ? 'Cập nhật thông tin thành công'
          : response.response.message;
      AlertUtils.alert({message});
    } else {
      const message
        = Utils.parseErrorMessage(response, error,
        'Cập nhật thông tin thất bại, vui lòng thử lại sau');
      AlertUtils.alert({message});
    }
  };

  render () {
    const {paymentMethod, promoCode, address, name, shippingCode, status, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        {status === 'succeed' && <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          containerContentStyle={styles.contentContainer}
          style={styles.container}>

          <Text
            style={[
              styles.inputTitleText, {
                marginTop: 24,
              }]}>
            Phương thức thanh toán
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='paymentMethodTextInput'
              value={paymentMethod}
              placeholder='Phương thức thanh toán'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('paymentMethod',
                text)}
              onSubmitEditing={() => this._focusTextInput(
                'promoCodeTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Mã giới thiệu
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='promoCodeTextInput'
              value={promoCode}
              placeholder='Mã giới thiệu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('promoCode',
                text)}
              onSubmitEditing={() => this._focusTextInput(
                'addressTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Địa chỉ
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='addressTextInput'
              value={address}
              placeholder='Địa chỉ'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('address',
                text)}
              onSubmitEditing={() => this._focusTextInput(
                'nameTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Tên người mua
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='nameTextInput'
              value={name}
              placeholder='Tên người mua'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('name',
                text)}
              onSubmitEditing={this._submit}/>
          </View>
          <Text
            style={styles.inputTitleText}>
            Mã vận đơn
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='shippingCodeTextInput'
              value={shippingCode}
              placeholder='Mã vận đơn'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('shippingCode',
                text)}
              onSubmitEditing={this._submit}/>
          </View>
          <TouchableOpacity
            activeOpacity={0.75}
            onPress={this._submit}
            style={styles.submit}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              CẬP NHẬT THÔNG TIN
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>
        </KeyboardAwareScrollView>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

// export default connect(mapStateToProps, mapDispatchToProps)(Screen);
export default EditOrderScreen;



// WEBPACK FOOTER //
// ./src/order/EditOrderScreen.js